module.exports = __webpack_public_path__ + "static/media/avatar.e848db82.jpg";